import { supabase } from '../../supabase'
import type {
  DatabaseRow,
  ProspectPayload,
  ProspectRow,
  RepositoryResult,
} from '../types/database.types'
import { failure, success } from './result'

export const ProspectsRepository = {
  async listOverview(): Promise<RepositoryResult<DatabaseRow[]>> {
    const { data, error } = await supabase.from('prospect_overview').select('*')
    return error ? failure(error) : success((data ?? []) as DatabaseRow[])
  },

  async getById(id: string): Promise<RepositoryResult<ProspectRow | null>> {
    const { data, error } = await supabase
      .from('prospects')
      .select('*')
      .eq('id', id)
      .maybeSingle()
    return error
      ? failure(error)
      : success((data ?? null) as ProspectRow | null)
  },

  async getContactChannels(
    id: string,
  ): Promise<RepositoryResult<DatabaseRow | null>> {
    const { data, error } = await supabase
      .from('prospects')
      .select('whatsapp, phone, instagram_url, facebook_url, email')
      .eq('id', id)
      .maybeSingle()

    return error
      ? failure(error)
      : success((data ?? null) as DatabaseRow | null)
  },

  async create(
    payload: ProspectPayload,
  ): Promise<RepositoryResult<ProspectRow>> {
    const { data, error } = await supabase
      .from('prospects')
      .insert(payload)
      .select('*')
      .single()
    return error ? failure(error) : success(data as ProspectRow)
  },

  async update(
    id: string,
    payload: ProspectPayload,
  ): Promise<RepositoryResult<ProspectRow>> {
    const { data, error } = await supabase
      .from('prospects')
      .update(payload)
      .eq('id', id)
      .select('*')
      .single()

    return error ? failure(error) : success(data as ProspectRow)
  },

  async listNiches(): Promise<RepositoryResult<DatabaseRow[]>> {
    const { data, error } = await supabase.from('niches').select('*')
    return error ? failure(error) : success((data ?? []) as DatabaseRow[])
  },

  async listSources(): Promise<RepositoryResult<DatabaseRow[]>> {
    const { data, error } = await supabase.from('sources').select('*')
    return error ? failure(error) : success((data ?? []) as DatabaseRow[])
  },
}
